import classNames from 'classnames';
import Moment from 'moment';
import React, { useEffect, useReducer } from 'react';
import DatePicker from 'react-datepicker';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import Notifications from 'react-notification-system-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as CustomerActions from '../../../common/services/customer/Actions';
import * as CustomerService from '../../../common/services/customer/Service';
import { CustomerError } from '../../../common/services/customer/Types';
import { CustomerDataDTO } from '../../../common/types/dto/CustomerDataDTO';
import { VehicleDocsDTO } from '../../../common/types/dto/VehicleDocsDTO';
// import imgDuaDATE from '../../assets/images/DUA_DATE.png';
// import imgDuaFrente from '../../assets/images/DUA_FRENTE.png';
// import imgDuaVerso from '../../assets/images/DUA_VERSO.png';
import cssForms from '../../assets/scss/Forms.scss';
import { RootState } from '../../base/RootReducer';
import { config } from '../../common/';
import { AppThunkDispatch } from '../types';

interface ValidateVehicleState {
    submitDocErrorText: string;
    vinErrorText: string;
    plateErrorText: string;
    fileFront: any;
    fileBack: any;
    fileFrontExt: string;
    fileBackExt: string;
    validateEmissionDate: Date | null;
    validateVin: string;
    showPlateInput: boolean;
    validatePlate: string;
    errorMessage: string;
    waitingForResponse: boolean;
}

export interface ValidateVehicleProps {
    onSucess: () => void;
    onCancel?: (event: React.MouseEvent<{}> | null) => void | null;
    validation: boolean;
    vehcode: number;
    header?: JSX.Element | null;
    className?: string | null;
}

interface ReduxStateProps {
    customerInfo: CustomerDataDTO | undefined;
}

interface ReduxDispatchProps {
    dispatch: AppThunkDispatch;
    customerActions: typeof CustomerActions;
    customerServiceActions: CustomerService.ServiceActions;
}

type ValidateVehicleProperties =
    ReduxStateProps
    & ReduxDispatchProps
    & ValidateVehicleProps;

const ValidateVehicle: React.FC<ValidateVehicleProperties> = (Props) => {
    const { t } = useTranslation();
    const initialState: ValidateVehicleState = {
        submitDocErrorText: '',
        vinErrorText: '',
        plateErrorText: '',
        fileFront: null,
        fileBack: null,
        fileFrontExt: '',
        fileBackExt: '',
        validateEmissionDate: null,
        validateVin: '',
        showPlateInput: false,
        validatePlate: '',
        errorMessage: '',
        waitingForResponse: false,
    };
    const [state, setState]: [ValidateVehicleState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    useEffect(() => {
        if (Props.customerInfo && Props.customerInfo.vehicles && Props.customerInfo.vehicles.length > 0) {
            Props.customerInfo.vehicles.map((vehicle) => {
                if (vehicle.vehcode === Props.vehcode) {
                    setState({
                        validateVin: vehicle.vin,
                        validatePlate: vehicle.licensePlate || '',
                        showPlateInput: vehicle.licensePlate === null || vehicle.licensePlate === undefined || vehicle.licensePlate === '' || !config.Constants.Regex.LicensePlateValidation.test(vehicle.licensePlate.toUpperCase()),
                    });
                }
            });
        }
    }, [Props.customerInfo, Props.vehcode]);

    // function b64toBlob(b64Data: string, contentType = '', sliceSize = 512) {
    //    const byteCharacters = atob(b64Data.split(',')[1]);
    //    const byteArrays = [];

    //    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    //        const slice = byteCharacters.slice(offset, offset + sliceSize);

    //        const byteNumbers = new Array(slice.length);
    //        for (let i = 0; i < slice.length; i++) {
    //            byteNumbers[i] = slice.charCodeAt(i);
    //        }

    //        const byteArray = new Uint8Array(byteNumbers);
    //        byteArrays.push(byteArray);
    //    }

    //    const blob = new Blob(byteArrays, { type: contentType });
    //    return blob;
    // }

    function handleFrontImageChange(accepted: File[]) {
        if (accepted && accepted[0]) { // Accepted list has 1 element (multiple = false)
            const file = accepted[0];

            const reader = new FileReader();
            reader.onload = (event: any) => {
                setState({
                    fileFront: event.currentTarget.result.split(',').pop(), // b64toBlob(event.currentTarget.result),
                    fileFrontExt: file.name.split('.').pop(),
                    submitDocErrorText: '',
                });
            };
            reader.readAsDataURL(file);

            // setState({
            //    fileFront: file,
            //    submitDocErrorText: '',
            // });
        } else {
            setState({ submitDocErrorText: t('profile:DropzoneFileError') });
        }
    }

    function handleBackImageChange(accepted: File[]) {
        if (accepted && accepted[0]) { // Accepted list has 1 element (multiple = false)
            const file = accepted[0];

            const reader = new FileReader();
            reader.onload = (event: any) => {
                setState({
                    fileBack: event.currentTarget.result.split(',').pop(), // b64toBlob(event.currentTarget.result),
                    fileBackExt: file.name.split('.').pop(),
                    submitDocErrorText: '',
                });
            };
            reader.readAsDataURL(file);

            // setState({
            //    fileBack: file,
            //    submitDocErrorText: '',
            // });
        } else {
            setState({ submitDocErrorText: t('profile:DropzoneFileError') });
        }
    }

    function validateDocForm() {
        if (state.waitingForResponse) {
            return false;
        }

        let isValid: boolean = true;
        if (state.fileFront == null) {
            setState({ submitDocErrorText: t('profile:fileNotSetError') });
            isValid = false;
        } else if (state.fileBack == null) {
            setState({ submitDocErrorText: t('profile:fileNotSetError') });
            isValid = false;
        } else if (state.validateVin === '') {
            setState({ vinErrorText: t('mandatory') });
            isValid = false;
        } else if (!config.Constants.Regex.VinValidation.test(state.validateVin)) {
            setState({ vinErrorText: t('signup:errors:vinValidationRegex') });
            isValid = false;
        } else if (state.validatePlate === '') {
            setState({ plateErrorText: t('mandatory') });
            isValid = false;
        }
        return isValid;
    }

    async function onEditDocSubmit(e: React.MouseEvent<{}> | null) {
        if (e) {
            e.preventDefault();
        }
        if (!validateDocForm()) {
            return;
        }
        if (!state.validateEmissionDate) {
            setState({
                errorMessage: t('profile:validateVehInvalidDate') });
            return;
        }
        try {
            if (state.fileFront && state.fileBack) {
                setState({
                    errorMessage: '',
                    waitingForResponse: true,
                });
                // convert to PNG to avoid server error
                // TODO
                const data: VehicleDocsDTO = {
                    doc1_FileName: 'DocFront',
                    doc1_FileExt: state.fileFrontExt,
                    doc1_Content: state.fileFront,
                    doc2_FileName: 'DocBack',
                    doc2_FileExt: state.fileBackExt,
                    doc2_Content: state.fileBack,
                    vehcode: Props.vehcode,
                    userInputPlate: state.validatePlate,
                    userInputVin: state.validateVin,
                    userInputDate: Moment(state.validateEmissionDate).format('YYYY-MM-DD'),
                };

                await Props.customerServiceActions.uploadVehicleDocs(data);
                Props.dispatch(Notifications.success({
                    title: t('success'),
                    message: t('profile:validateVehicle:success'),
                    position: 'tc',
                    autoDismiss: 5,
                }));
                setState({ waitingForResponse: false });
                Props.onSucess();
            }
        } catch (error) {
            if (error instanceof CustomerError) {
                const exceptionType: string = error.customerErrorInfo.exceptionType || 'UnknownException';
                const exceptionErrorMsg: string = t(`exception:${exceptionType.split('.').pop()}`);
                setState({ submitDocErrorText: exceptionErrorMsg });
                Props.dispatch(Notifications.error({
                    title: t('error'),
                    message: exceptionErrorMsg,
                    position: 'tc',
                    autoDismiss: 5,
                }));
                setState({
                    errorMessage: exceptionErrorMsg,
                    waitingForResponse: false,
                });
            } else {
                let errorMsg = t('exception:Exception');
                if (error && (error as any).response && (error as any).response.status === 413) {
                    errorMsg = t('exception:BigFileException');
                }
                setState({
                    errorMessage: errorMsg,
                    waitingForResponse: false,
                });
                throw error;
            }
        }
    }

    function onValidateEmissionDateChange(date: Date) {
        setState({ validateEmissionDate: date });
    }

    function onValidateVinChange(event: React.FormEvent<HTMLInputElement>) {
        setState({ validateVin: event.currentTarget.value });
    }

    function onValidatePlateChange(event: React.FormEvent<HTMLInputElement>) {
        setState({ validatePlate: event.currentTarget.value });
    }

    const loadingStr = t('loadingText');
    const validateStr = t('profile:validate');

    if (Props.validation) {
        return (
            <React.Fragment>
                <div className={classNames(['meu-perfil', Props.className])}>
                    <div className={'dados-pacotes'}>
                        {Props.header ? Props.header : <h3>{t('profile:subTitleEdit4')}</h3>}
                        <p className={'info-validar-viatura'}>{t('profile:duaRequiredOffer')}</p>
                        <p className={'info-validar-viatura'}>{t('profile:duaRequired')}</p>

                        <div className={classNames(['grid-x', 'grid-margin-x', 'margin-top-2'])}>
                            <div className={classNames(['cell', 'medium-12', 'medium-order-1', 'small-order-3'])}>
                                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                                    <div className={classNames(['cell', 'medium-6', 'small-12', 'medium-order-1', 'small-order-1'])}>
                                        <label className={classNames(['clipe', 'margin-bottom-1'])}>{t('profile:frontSide')}</label>
                                    </div>
                                    <div className={classNames(['cell', 'medium-6', 'small-12', 'medium-order-2', 'small-order-3'])}>
                                        <label className={classNames(['clipe', 'margin-bottom-1'])}>{t('profile:backSide')}</label>
                                    </div>
                                    <div className={classNames(['cell', 'medium-6', 'small-12', 'medium-order-3', 'small-order-2', 'margin-bottom-1'])}>
                                        <Dropzone
                                            onDrop={handleFrontImageChange}
                                            multiple={false}
                                            accept={{ 'image/jpeg': ['.jpeg', '.jpg'], 'image/png': ['.png'] }}
                                            minSize={undefined}
                                            maxSize={6000000}
                                        >
                                            {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                                <div {...getRootProps()} className={cssForms.dropZone}>
                                                    <input {...getInputProps()} />
                                                    <div className={cssForms.dropZoneContainer}>{t('profile:dropzone.label1')}</div>
                                                </div>
                                            )}
                                        </Dropzone>
                                        {state.fileFront != null ? <p className={'info-validar-viatura'}>{t('profile:fileSet')}</p> : ''}
                                    </div>
                                    <div className={classNames(['cell', 'medium-6', 'small-12', 'medium-order-4', 'small-order-4', 'margin-bottom-1'])}>
                                        <Dropzone
                                            onDrop={handleBackImageChange}
                                            multiple={false}
                                            accept={{'image/jpeg': ['.jpeg', '.jpg'], 'image/png': ['.png']}}
                                            minSize={undefined}
                                            maxSize={6000000}
                                        >
                                            {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                                <div {...getRootProps()} className={cssForms.dropZone}>
                                                    <input {...getInputProps()} />
                                                    <div className={cssForms.dropZoneContainer}>{t('profile:dropzone.label1')}</div>
                                                </div>
                                            )}
                                        </Dropzone>
                                        {state.fileBack != null ? <p className={'info-validar-viatura'}>{t('profile:fileSet')}</p> : ''}
                                    </div>
                                </div>
                            </div>
                            <div className={classNames(['cell', 'medium-12', 'medium-order-2', 'small-order-1', 'margin-top-1'])}>
                                <p className={'info-validar-viatura'}>{t('profile:validateVehRequired')}</p>
                            </div>
                            <div className={classNames(['cell', 'medium-12', 'medium-order-3', 'small-order-2', 'margin-top-1'])}>
                                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                                    <div className={classNames(['cell', 'medium-6', 'small-12'])}>
                                        <label className={'label-space'} htmlFor="data-de-emissao">
                                            {t('signup:formFields.emissionDate')}
                                        </label>
                                        <DatePicker name="data-de-emissao" onChange={onValidateEmissionDateChange} selected={state.validateEmissionDate} dateFormat={'yyyy-MM-dd'} locale={'pt'} adjustDateOnChange={true} />
                                    </div>
                                    <div className={classNames(['cell', 'medium-6', 'small-12'])}>
                                        <label className={'label-space'} htmlFor="numero-de-quadro">
                                            {t('signup:formFields.vin')}
                                        </label>
                                        <input type="text" name="numero-de-quadro" value={state.validateVin} onChange={onValidateVinChange} maxLength={config.Validations.VIN.MaxLength} className={cssForms.inputUppercase} pattern="[A-Z0-9]" />
                                        <div className="error-message">{state.vinErrorText}</div>
                                    </div>
                                    {state.showPlateInput && (
                                        <div className={classNames(['cell', 'medium-6', 'small-12'])}>
                                            <label className={'label-space'} htmlFor="data-de-emissao">
                                                {t('signup:formFields.licensePlate')}
                                            </label>
                                            <InputMask type="text" value={state.validatePlate} onChange={onValidatePlateChange} maskChar="" mask="**-**-**" className={cssForms.inputUppercase} pattern="[A-Z0-9]" />
                                            <div className="error-message">{state.plateErrorText}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={classNames(['cell', 'medium-12', 'medium-order-4', 'small-order-4'])}>
                                {state.submitDocErrorText && (<div className="error-message">{state.submitDocErrorText}</div>)}
                                {!state.submitDocErrorText && state.errorMessage && (<div className="error-message">{state.errorMessage}</div>)}
                                <div className={classNames(['small', 'button-group', 'dados-pacotes'])}>
                                    <button className={classNames(['button', 'alterar'])} onClick={onEditDocSubmit} disabled={state.waitingForResponse}>{state.waitingForResponse ? loadingStr : validateStr}</button>
                                    {Props.onCancel && (
                                        <button className={classNames(['button', 'cancelar', 'margin-left-1'])} onClick={Props.onCancel}>{t('cancel')}</button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
    return null;
};

const mapStateToProps = (store: RootState) => ({
    customerInfo: store.customerState.customerData.data.customerData,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    dispatch,
    customerActions: bindActionCreators(CustomerActions, dispatch),
    customerServiceActions: CustomerService.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ValidateVehicle);
